<template>
  <div id="dashboard-content">
    <div class="mb-4 d-flex">
      <h4>Pengajuan HET</h4>
    </div>

    <template v-if="loading">
      <div class="text-center mt-5">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-3 text-muted">Memuat data buku...</p>
      </div>
    </template>

    <template v-else-if="hetList.length == 0">
      <div class="text-center mt-5">
        <img width="60" src="@/assets/not-found.png" class="img-fluid" alt="" />
        <h4 class="text-center mt-2">Data belum tersedia.</h4>
        <p class="text-muted">Buku bapak/ibu yang lolos penilaian akan tampil di sini, untuk dilengkapi data HET-nya.</p>
      </div>
    </template>

    <template v-else>
      <div class="card border-0 shadow-sm p-3">
        <div class="input-group mb-3 w-50">
          <div class="input-group-prepend">
            <span
              class="input-group-text bg-white border-right-0"
              id="basic-addon1"
              ><i class="fa fa-search"></i
            ></span>
          </div>
          <input
            type="text"
            class="form-control border-left-0"
            placeholder="Cari judul buku"
            v-model="keyword"
          />
        </div>
        <div class="table-responsive">
          <table class="table table-stripped mt-1 text-center">
            <thead class="bg-grey-200">
              <tr class="rounded-pill">
                <th scope="col" class="text-left">No</th>
                <th scope="col" class="text-left">Judul Buku</th>
                <th scope="col">Event</th>
                <th scope="col">Mata Pelajaran</th>
                <th scope="col">Jenjang</th>
                <th scope="col">Status</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="filteredHetList.length == 0">
                <td colspan="7">Pencarian tidak ditemukan</td>
              </tr>
              <tr
                v-else
                v-for="(item, index) in filteredHetList"
                :key="item.id || index"
              >
                <td class="text-left">{{ index + 1 }}</td>
                <td class="text-left">{{ item.judul_buku || '-' }}</td>
                <td>{{ item.event_name || '-' }}</td>
                <td>{{ item.mata_pelajaran || '-' }}</td>
                <td>{{ item.jenjang || item.jenjang_sekolah_id || '-' }}</td>
                <td>
                  <span
                    :class="{
                      'text-success': item.status === 'approved',
                      'text-info': item.status === 'updated',
                      'text-warning': item.status === 'pending' || item.status === 'open',
                      'text-danger': item.status === 'rejected',
                      'text-secondary': !item.status || item.status === 'draft'
                    }"
                  >
                    {{ ucfirst(item.status) || 'Draft' }}
                  </span>
                </td>
                <td width="170">
                  <div class="dropright">
                    <button
                      type="button"
                      class="btn btn-sm rounded-0 bg-white"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fa-solid fa-ellipsis fa-lg"></i>
                    </button>
                    <div class="dropdown-menu">
                      <span
                        role="button"
                        @click="viewDetail(item)"
                        class="dropdown-item px-2"
                      >
                        <i
                          class="fa fa-eye rounded text-primary bg-primary-100 p-2"
                        ></i>
                        &nbsp;&nbsp;Lihat Detail
                      </span>
                      <router-link
                        :to="{
                          name: 'PengajuanHET-Edit',
                          params: { id: item.id },
                        }"
                        class="dropdown-item px-2"
                      >
                        <i
                          class="fa fa-pencil rounded text-primary bg-primary-100 p-2"
                        ></i>
                        &nbsp;&nbsp;Edit
                      </router-link>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>

    <div class="row my-4 text-right">
      <div class="col-md-12">
        <nav id="paging"></nav>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "PengajuanHET",
  data() {
    return {
      hetList: [],
      keyword: "",
      loading: false,
      selectedItem: null,
    };
  },
  computed: {
    filteredHetList() {
      const kw = this.keyword ? this.keyword.toLowerCase() : "";
      return this.hetList.filter((item) => {
        const title = (item.judul_buku || (item._raw && item._raw.book && item._raw.book.judul_buku) || "").toString().toLowerCase();
        return title.includes(kw);
      });
    },
  },
  methods: {
    getUserIdFromToken() {
      try {
        const user = localStorage.getItem("user");
        if (user) {
          const userData = JSON.parse(user);
          return userData.id || userData.user_id || null;
        }
        return null;
      } catch (e) {
        console.error("Error parsing user data:", e);
        return null;
      }
    },

    ucfirst(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    fetchHETList() {
      console.log('fetchHETList method called');
      this.loading = true;
      
      const userId = this.getUserIdFromToken();
      const token = localStorage.getItem("token");
      console.log('User ID and Token check:', { userId, hasToken: !!token });
      
      if (!userId || !token) {
        console.error("User ID or token not found", { userId: !!userId, token: !!token });
        this.loading = false;
        return;
      }

      console.log("Fetching books for user:", userId);
      
      fetch(`https://het-buku.cloudapp.web.id/bookspec/books/publisher/${userId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "X-API-Key": "dfjscmksi4395flSsafl402vlWdsflkWQ",
          "Content-Type": "application/json"
        },
      })
      .then(response => {
        console.log("API Response status:", response.status);
        
        if (!response.ok) {
          return response.text().then(errorText => {
            console.error("API Error:", errorText);
            throw new Error(`HTTP error! status: ${response.status}`);
          });
        }
        
        return response.json();
      })
      .then(result => {
        console.log("API Response:", result);

        // API returns { data: { books: [...] } }
        let books = [];
        if (result.data && result.data.books && Array.isArray(result.data.books)) {
          books = result.data.books;
        } else if (result.data && Array.isArray(result.data)) {
          books = result.data;
        } else if (Array.isArray(result)) {
          books = result;
        } else if (result.books && Array.isArray(result.books)) {
          books = result.books;
        }

        console.log("Books array:", books);

        // Map API response to hetList format for display in table
        this.hetList = books.map((book, index) => {
          const src = book.book || book;
          return {
            id: book.id || src.id || index,
            isbn: src.isbn || src.ISBN || "-",
            judul_buku:
              src.judul_buku || src.judul || src.title || src.book_title || "-",
            event_name: src.event_name || book.event_name || "-",
            nama_penulis:
              src.penulis || src.author || src.nama_penulis || src.writer || "-",
            mata_pelajaran:
              src.mata_pelajaran || src.mata_pelajaran || src.subject || src.mapel || "-",
            tahun_terbit:
              src.tahun_terbit || src.year || src.publication_year || src.publish_year || "-",
            edisi: src.edisi || src.edition || "-",
            kategori: src.category || src.kategori || src.type || "-",
            jenjang: src.jenjang || src.school_level || src.jenjang_sekolah_id || "-",
            jenjang_sekolah_id: src.jenjang_sekolah_id || "-",
            kelas: src.kelas || src.class || "-",
            bentuk_buku: src.bentuk_buku || src.book_format || src.format || "-",
            lebar_buku: src.lebar_buku || src.width || src.book_width || "-",
            panjang_buku: src.panjang_buku || src.height || src.book_height || "-",
            jumlah_halaman_isi:
              src.jumlah_halaman_isi || src.content_pages || src.pages || "-",
            jumlah_halaman_kulit: src.jumlah_halaman_kulit || src.cover_pages || "-",
            kertas_isi_jenis: src.kertas_isi_jenis || src.content_paper_type || "-",
            kertas_isi_gram: src.kertas_isi_gram || src.content_paper_weight || "-",
            kertas_kulit_jenis: src.kertas_kulit_jenis || src.cover_paper_type || "-",
            kertas_kulit_gram: src.kertas_kulit_gram || src.cover_paper_weight || "-",
            warna_isi: src.warna_isi || src.content_color || "-",
            warna_kulit: src.warna_kulit || src.cover_color || "-",
            finishing: src.finishing || src.binding_type || src.binding || "-",
            laminating: src.laminating || "-",
            status: book.status || book.het_status || src.status || "draft",
            submission_date: book.created_at || src.created_at || book.submission_date || src.submission_date || new Date().toISOString(),
            // Additional fields
            nuib: src.nuib || book.nuib || "-",
            nama_penerbit:
              src.nama_penerbit || src.publisher || book.nama_penerbit || "-",
            jenjang_buku_id: src.book_level_id || src.jenjang_buku_id || "-",
            tipe: src.tipe || book.tipe || book.type || "BNT",
            // Boolean fields
            emboss: src.emboss || false,
            spot_uv: src.spot_uv || false,
            potong_sudut: src.potong_sudut || false,
            perlengkapan: src.perlengkapan || false,
            pond: src.pond || false,
            polymas: src.polymas || false,
            shrink: src.shrink || false,
            stiker_pembatas: src.stiker_pembatas || null,
            // keep original book payload available
            _raw: book,
          };
        });

        console.log("Final hetList:", this.hetList);
      })
      .catch(err => {
        console.error("Error fetching books:", err);
        console.error("Error details:", {
          name: err.name,
          message: err.message,
          stack: err.stack
        });
        this.hetList = [];
        
        // Show user-friendly error if needed
        if (err.message.includes('CORS') || err.message.includes('Network')) {
          console.warn('Network or CORS error - API might be unreachable');
        }
      })
      .finally(() => {
        this.loading = false;
        console.log('fetchHETList finished, hetList length:', this.hetList.length);
      });
    },

    async deleteHET(id) {
      // Show confirmation dialog using SweetAlert
      const result = await Swal.fire({
        title: "Konfirmasi Penghapusan",
        text: "Apakah anda yakin akan menghapus data pengajuan HET ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Ya, Hapus!",
        cancelButtonText: "Batal",
      });

      if (!result.isConfirmed) return;

      try {
        const token = localStorage.getItem("token");
        if (!token) {
          Swal.fire({
            title: "Error",
            text: "Token authorization tidak ditemukan. Silakan login.",
            icon: "error",
          });
          return;
        }

        // Show loading state
        Swal.fire({
          title: "Menghapus...",
          text: "Mohon tunggu",
          icon: "info",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        // Using DELETE endpoint
        const response = await fetch(
          `https://api.buku.kemendikdasmen.go.id/api/het/delete/${id}`,
          {
            method: "DELETE",
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );

        const result = await response.json();

        if (result.meta && result.meta.status) {
          Swal.fire({
            title: "Berhasil!",
            text: "Data pengajuan HET berhasil dihapus.",
            icon: "success",
          });
          // Refresh list
          this.fetchHETList();
        } else {
          Swal.fire({
            title: "Gagal",
            text: "Gagal menghapus data: " + (result.meta?.message || "Unknown error"),
            icon: "error",
          });
        }
      } catch (err) {
        console.error("Error deleting HET:", err);
        Swal.fire({
          title: "Gagal",
          text: "Gagal menghapus data. Silakan coba lagi.",
          icon: "error",
        });
      }
    },

    viewDetail(item) {
      this.$router.push({
        name: "PengajuanHET-Detail",
        params: { id: item.id },
      });
    },
  },
  created() {
    console.log('Component created, calling fetchHETList...');
    this.fetchHETList();
  },
  mounted() {
    console.log('Component mounted');
    // Debug: check component state
    console.log('Component state:', {
      hetListLength: this.hetList.length,
      loading: this.loading,
      hasUserId: !!this.getUserIdFromToken(),
      hasToken: !!localStorage.getItem('token')
    });
  },
  beforeCreate() {
    const logged_in = localStorage.getItem("user");
    if (!logged_in) {
      this.$router.push("/login");
    }
  },
};
</script>

<style>
.spinner-border {
  color: #007bff;
  width: 3rem;
  height: 3rem;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
</style>
